module.exports = __webpack_public_path__ + "static/media/jean-grey.99906bc7.png";